module.exports = __webpack_public_path__ + "img/fullscreen-close.ec87eda0.svg";